/**
 * @generated SignedSource<<75bf96d41aa8c5efb3cce471a7fbb147>>
 * @relayHash 7b673decd3cd4ea52b586760c475ecea
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b673decd3cd4ea52b586760c475ecea

import { ConcreteRequest } from 'relay-runtime';
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type UpdateChatStatusInput = {
  isEnglishActive: boolean;
  isFrenchActive: boolean;
  isGermanActive: boolean;
  isItalianActive: boolean;
  isMedical: boolean;
};
export type useUpdateChatStatusMutation$variables = {
  input: UpdateChatStatusInput;
};
export type useUpdateChatStatusMutation$data = {
  readonly updateChatStatus: {
    readonly chatStatus: ReadonlyArray<{
      readonly canCreateAdministrativeChats: boolean;
      readonly canCreateMedicalChats: boolean;
      readonly changedAt: string;
      readonly changedBy: string;
      readonly id: string;
      readonly language: Language;
    }> | null;
  };
};
export type useUpdateChatStatusMutation = {
  response: useUpdateChatStatusMutation$data;
  variables: useUpdateChatStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateChatStatusPayload",
    "kind": "LinkedField",
    "name": "updateChatStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatStatus",
        "kind": "LinkedField",
        "name": "chatStatus",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateMedicalChats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateAdministrativeChats",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "changedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "changedBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateChatStatusMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateChatStatusMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "7b673decd3cd4ea52b586760c475ecea",
    "metadata": {},
    "name": "useUpdateChatStatusMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cd932de68910af6c185f1509eb6a29b8";

export default node;
